// Custom-length picker: shows the size input only when the buyer chooses to enter a size now.
class CustomSizeField extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController()
    this.addEventListener('change', () => this.apply(), { signal: this.abort.signal })
    this.apply()
  }

  disconnectedCallback() {
    this.abort?.abort()
  }

  apply() {
    const entering = this.querySelector('input[type="radio"]:checked')?.value === 'Enter size'
    const entry = this.querySelector('[data-size-entry]')
    const contact = this.querySelector('[data-size-contact]')
    const input = this.querySelector('input[name="properties[Custom size]"]')
    if (!entry || !contact || !input) return
    entry.hidden = !entering
    contact.hidden = entering
    input.required = entering
    input.disabled = !entering
  }
}

customElements.define('custom-size-field', CustomSizeField)
